"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferedAsType = exports.OfferingType = void 0;
var OfferingType;
(function (OfferingType) {
    OfferingType["INDIVIDUAL"] = "INDIVIDUAL";
    OfferingType["GROUP"] = "GROUP";
    OfferingType["TOUR"] = "TOUR";
    OfferingType["COURSE"] = "COURSE";
    OfferingType["DUMMY"] = "DUMMY";
})(OfferingType = exports.OfferingType || (exports.OfferingType = {}));
var OfferedAsType;
(function (OfferedAsType) {
    OfferedAsType["ONE_TIME"] = "ONE_TIME";
    OfferedAsType["PRICING_PLAN"] = "PRICING_PLAN";
})(OfferedAsType = exports.OfferedAsType || (exports.OfferedAsType = {}));
//# sourceMappingURL=offering.dto.js.map